export const meta: BlockMeta = {
  title: "Numbered Rows Item",
  description: "A single numbered row",
  keywords: ["content"],
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/numbered-rows-item", (props) => {
  return (
    <li className="!type-title-s-medium [&_.sub-title-text]:!type-title-s-medium mt-2 mb-5">
      <EditableText
        as="p"
        className="sub-title-text !py-0 inline-block pl-numberedRowsIndent mb-3"
        store="title"
        inlineToolbar={false}
        defaultValue="Example title"
        placeholder="Example title"
      />
      <div className="!type-body-m-serif [&_p]:pl-numberedRowsIndent">
        <InnerBlocks allowedBlocks={["core/paragraph", "acf/content-numbered-rows-sub"]} orientation="vertical" />
      </div>
    </li>
  )
})
